
export enum ContactType {
    Authorised_Agency = 0,
    Department_Of_Transport = 1,
    Other = 2
}

export interface Coordinates {
    lat: number;
    lng: number;
};
export interface Location {
    coordinates: Coordinates;
    contactName: string;
    type: number;
    serviceType: string;
    categoryId: string;
    subcategoryId: string;
    detailsPage: string;
    operationalStatus: string;
    openingHoursInfo: string;
    isLicensingCentre: boolean;
    address1: string;
    address2: string;
    postcode: number;
    isManualOutage: boolean;
}
export interface Suburb {
    lat: number;
    lng: number;
    postcode: number;
    locality: string;
}